// extracted by mini-css-extract-plugin
module.exports = {"download":"Download-module--download--1qqUK"};